import { Row } from 'antd';
import { Text } from 'farmhub-ui-core';
import styled from 'styled-components';

import { overlay } from 'styled';

export const CertificationWrapper = styled(Row)`
  display: flex;
  flex-direction: row !important;
`;

export const MobileWrapper = styled.div`
  width: 100%;
  // padding: ${p => p.theme.app.padding.vertical}
  //   ${p => p.theme.app.padding.horizontal};
`;

export const DeleteText = styled(Text)`
  font-weight: ${p => p.theme.font.weight.regular};
  font-size: ${p => p.theme.font.size.xs};
  text-decoration-line: underline;
  color: ${p => p.theme.colors.text.orange};
  cursor: pointer;

  text-underline-offset: 3px;
`;

export const Content = styled.div`
  width: 100%;
`;

export const SectionData = styled.div`
  width: 100%;
  height: 460px;
  overflow: scroll;
  overflow-x: hidden;

  ${overlay}
`;

export const SectionDataMobile = styled.div`
  width: 100%;
  height: calc(100vh - 242px);
  overflow: scroll;
  overflow-x: hidden;

  ${overlay}
`;
